module.exports = __webpack_public_path__ + "img/geofisica_4-3_1536.3cfebbd0.jpg";